export const blue = {
  50: "#FBFCFF",
  100: "#F5F8FF",
  200: "#E3EBFF",
  300: "#C5D6FF",
  400: "#87A0E1",
  500: "#2F54E6",
  600: "#193DCD",
  700: "#0023AF",
  800: "#0F267F",
  900: "#09152F",
};

export const grey = {
  100: "#F5F5F5",
  200: "#E0E0E0",
  400: "#BDBDBD",
  600: "#757575",
};

export const action = {
  ok_50: "#E8F5E9",
  ok_700: "#419C45",
  warning_50: "#FFF3E0",
  warning_500: "#E28A08",
  warning_900: "#A96808",
  error_50: "#FFEBEE",
  error_500: "#F2473C",
};

export const tags = {
  raspberry_50: "#FEEBF1",
  raspberry_600: "#FE4A68",
  blueberry_50: "#EFE6FB",
  blueberry_600: "#6023D5",
  kiwi_50: "#EFF0BE",
  kiwi_600: "#AFA21E",
  blueish_50: "#E1F4FA",
  blueish_600: "#1997CD",
  lemon_50: "#FFF2AF",
  lemon_600: "#FAD826",
  mint_50: "#C4F9EF",
  mint_600: "#44B490",
  pink_50: "#FFC0F9",
  pink_600: "#FF00E5",
  cherry_50: "#FFC2C2",
  cherry_600: "#C30000",
  nightblue_50: "#87B6C8",
  nightblue_600: "#05384C",
  terracota_50: "#FFCEB3",
  terracota_600: "#FF7B02",
  eggplant_50: "#EFCAD7",
  eggplant_600: "#5F0324",
  green_50: "#F1FFBB",
  green_600: "#84AE23",
  mousegrey_50: "#CBCFE3",
  mousegrey_600: "#42475E",
  viola_50: "#EDBBFF",
  viola_600: "#5F3AAC",
  tulip_50: "#F0D1DE",
  tulip_600: "#FF2B2B",
  marron_50: "#F2CF92",
  marron_600: "#916312",
  orange_50: "#FEBCA0",
  orange_600: "#E04B00",
  lime_50: "#D8FFD6",
  lime_600: "#0AD800",
  pinetree_50: "#AEC3B4",
  pinetree_600: "#005C1A",
  turquoise_50: "#D2FFFF",
  turquoise_600: "#0AE9E9",
};
